import { useStore } from "hooks/use-store";
import { TextStat } from "./text-stat";
import { useTranslation } from "react-i18next";
import { roundNumber } from "utils/formatters";

interface RedImpactsStatProps {
  labelOnTop?: boolean;
}

export const RedImpactsStat = ({ labelOnTop }: RedImpactsStatProps) => {
  const { t } = useTranslation();

  const redImpacts = useStore((state) => state.redImpacts);
  const label = t("dashboard.red_impacts");

  return (
    <TextStat
      label={label}
      value={roundNumber(redImpacts.toString()).toString()}
      labelOnTop={labelOnTop}
      labelClassName="fill-primary-400"
      valueClassName="fill-white"
    />
  );
};
